"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadDSN = void 0;
var OrCadDSN;
(function (OrCadDSN) {
    let SymbolNameEnum;
    (function (SymbolNameEnum) {
        SymbolNameEnum["Offpage"] = "OFFPAGE";
        SymbolNameEnum["OffpageBothIn"] = "OFFPAGE_BOTH<>-IN";
        SymbolNameEnum["OffpageleftL"] = "OFFPAGELEFT-L";
        SymbolNameEnum["OffpagerightL"] = "OFFPAGERIGHT-L";
        SymbolNameEnum["OffpageleftB"] = "OFFPAGELEFT-B";
        SymbolNameEnum["OffpagerightB"] = "OFFPAGERIGHT-B";
        SymbolNameEnum["OffpageleftR"] = "OFFPAGELEFT-R";
        SymbolNameEnum["OffpagerightR"] = "OFFPAGERIGHT-R";
        SymbolNameEnum["OffpageInR"] = "OFFPAGE-IN-R";
        SymbolNameEnum["OffpageInL"] = "OFFPAGE-IN-L";
        SymbolNameEnum["OffpageOutR"] = "OFFPAGE-OUT-R";
        SymbolNameEnum["OffpageOutL"] = "OFFPAGE-OUT-L";
        SymbolNameEnum["PortbothL"] = "PORTBOTH-L";
        SymbolNameEnum["PortbothR"] = "PORTBOTH-R";
        SymbolNameEnum["PortleftL"] = "PORTLEFT-L";
        SymbolNameEnum["PortleftR"] = "PORTLEFT-R";
        SymbolNameEnum["PortnoR"] = "PORTNO-R";
        SymbolNameEnum["PortrightL"] = "PORTRIGHT-L";
        SymbolNameEnum["PortrightR"] = "PORTRIGHT-R";
        SymbolNameEnum["Off_L_bi"] = "OFF_L_BI";
    })(SymbolNameEnum = OrCadDSN.SymbolNameEnum || (OrCadDSN.SymbolNameEnum = {}));
    OrCadDSN.OCCURRENCE_NET_SYSTEM_ID_PROP_PREFIX = '@occurrence-net-system-id:';
})(OrCadDSN || (exports.OrCadDSN = OrCadDSN = {}));
//# sourceMappingURL=LogicalSchema.js.map